module.exports = __webpack_public_path__ + "static/media/pets-step-info.a855fe6d.svg";